import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import axios from 'axios';
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';
import Invoice from 'components/Coupon/Invoice';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';

export default function InvoicePreview(props) {
  const { open, setOpenInvoice, orderNo, getDataList } = props;

  const [invoiceInfo, setInvoiceInfo] = useState({});

  const createInvoice = async (e) => {
    const page = document.getElementById('page');

    const canvas = await html2canvas(page, { scale: 4 });
    const imageFile = canvas.toDataURL('image/jpeg');
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const widthRatio = pageWidth / canvas.width;
    const customHeight = canvas.height * widthRatio;
    doc.addImage(imageFile, 'png', 0, 0, pageWidth, customHeight);

    const docBlob = doc.output('blob');
    const docFile = new File([docBlob], 'name.pdf');

    let frm = new FormData();
    frm.append('orderNo', orderNo);
    frm.append('pdfFile', docFile);
    Object.keys((key) => {
      frm.append(key, invoiceInfo[key]);
    });

    const response = await axios.post(`/api/form/invoice`, frm, { headers: { 'Content-Type': 'multipart/form-data' } });
    if (response) {
      setInvoiceInfo(response.data);
    }
    setOpenInvoice(false);
  };

  const getInvoiceInfo = async (e) => {
    const response = await axios.get(`/api/form/invoice`, { params: { orderNo: orderNo } });
    if (response) {
      setInvoiceInfo(response.data);
    }
  };

  const handleClose = (e) => {
    setOpenInvoice(false);
  };

  useEffect(() => {
    if (open && orderNo) {
      getInvoiceInfo();
    }
  }, [open, orderNo]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xl" aria-labelledby="draggable-dialog-title">
      <DialogContent>
        <Invoice orderNo={orderNo} invoiceInfo={invoiceInfo} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={createInvoice}>
          인보이스 생성
        </Button>
        <Button variant="outlined" color="success" onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}
